import React, { useContext } from "react";
import { View, StyleSheet, Image } from "react-native";
import NtText from "../../../components/NtText";
import NtTouchableEffect from "../../../components/NtTouchableEffect";
import NtSectionButton from "./NtSectionButton";
import { useNavigation, useRoute } from "@react-navigation/native";
import routes from "../../../navigation/routes";
import UserContext from "../../../context/UserContext";
import { useMobile } from "../../../hooks/useMobile";
import NtMarketingLogo from "./NtMarketingLogo";

function NtMarketingPageContainerHeader({}) {
  const nav = useNavigation();
  const router = useRoute();
  const context = useContext(UserContext);
  const isMobile = useMobile();

  const links = [
    {
      id: routes.business,
      title: "Business",
      action: () => {
        nav.navigate(routes.business);
      },
    },
    {
      id: routes.hospitality,
      title: "Hospitality",
      action: () => {
        nav.navigate(routes.hospitality);
      },
    },
    {
      id: routes.plans,
      title: "Residential",
      action: () => {
        nav.navigate(routes.plans);
      },
    },

    {
      id: routes.mobile,
      title: "Mobile",
      action: () => {
        nav.navigate(routes.mobile);
      },
    },
    {
      id: "maritime",
      title: "Maritime",
      action: () => {
        window.open("https://ntmaritime.com");
      },
    },
    {
      id: routes.gov,
      title: ".Gov",
      action: () => {
        nav.navigate(routes.gov);
      },
    },
  ];

  const renderLinks = (containerStyle) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
          },
          containerStyle,
        ]}
      >
        {links.map((each) => renderRow(each))}
      </View>
    );
  };

  const renderRow = (item, containerStyle) => {
    const selected = router?.name == item.id;
    return (
      <NtTouchableEffect
        key={item.id}
        style={[
          {
            marginRight: 15,
            // alignItems: "center",
          },
          containerStyle,
        ]}
        onPress={item.action}
      >
        <NtText
          style={[
            {
              color: "white",
              fontWeight: "600",
              fontSize: 12,
            },
            selected ? {} : {},
          ]}
        >
          {item.title}
        </NtText>
        {selected && <View style={{ backgroundColor: "white", height: 2 }} />}
      </NtTouchableEffect>
    );
  };

  return (
    <View style={styles.container}>
      <View style={{ width: "100%", maxWidth: "90%" }}>
        <View
          style={{ flexDirection: "row", alignItems: "center", width: "100%" }}
        >
          <NtMarketingLogo
            onPress={() => {
              nav.navigate(routes.marketing);
            }}
          />

          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "flex-end",
              flexDirection: "row",
            }}
          >
            {!isMobile && renderLinks()}

            {/* buttons.... */}
            <NtSectionButton
              containerStyle={{ marginRight: 10 }}
              color="white"
              title="Sign In"
              onPress={() => {
                window.open(
                  "https://my.ntconnect.com/user/login/oauth2/service/connect"
                );
              }}
            />
          </View>
        </View>

        {isMobile && renderLinks({ marginTop: 8 })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "transparnet",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
});

export default NtMarketingPageContainerHeader;
